import { JWTPayload } from './tokenUtils';
import { isAnalyticsTurnedOn } from '@/constants';
import AppConfig, { IS_DEVELOPMENT_ENV, IS_STAGING_ENV } from '@/AppConfig';
import clevertap from 'clevertap-web-sdk';

export const initTracker = () => {
  // CleverTap initialization
  clevertap.privacy.push({ optOut: false }); // Set the flag to true, if the user of the device opts out of sharing their data
  clevertap.privacy.push({ useIP: false }); // Set the flag to true, if the user agrees to share their IP data
  clevertap.init(AppConfig.CLEVERTAP_ACCOUNT_ID, 'in1');
};

const track = ({ event = '', data = {} }) => {
  if (IS_DEVELOPMENT_ENV || IS_STAGING_ENV) {
    window.dev.i('SEGMENT: track', event, data);
  }
  if (window?.NativeBridge && window?.NativeBridge.callAnalytics) {
    window?.NativeBridge?.callAnalytics?.(event, JSON.stringify(data));
  } else if (isAnalyticsTurnedOn) {
    try {
      if (!clevertap) {
        console.warn(
          'CleverTap script was not loaded in the browser. Hence tracking event to CleverTap failed'
        );
        return;
      }
      clevertap.event.push(event, data);
    } catch (e) {
      console.error(
        'Error encountered while trying to send tracking event to CleverTap',
        e
      );
    }
  }
};

const identifyUserToAnalytics = (user: Partial<JWTPayload>) => {
  if (isAnalyticsTurnedOn) {
    try {
      if (!clevertap) {
        console.warn(
          'CleverTap script was not loaded in the browser. Hence identifying user failed'
        );
        return;
      }
      clevertap.profile.push({
        Site: {
          Identity: user.memberId!,
          Email: user.emailId,
          LastSeenAt: new Date(),
          OrganisationId: user.organisationId,
        },
      });
    } catch (e) {
      console.error(
        'Error encountered while trying to identify user on CleverTap',
        e
      );
    }
  }
};

const trackPageView = ({
  screenName,
  options,
  category,
}: {
  screenName: string;
  options?: unknown;
  category?: string;
}) => {
  if (window?.NativeBridge && window?.NativeBridge.sendScreen) {
    window?.NativeBridge?.sendScreen?.(
      screenName,
      JSON.stringify(options),
      category
    );
  } else if (isAnalyticsTurnedOn) {
    try {
      if (!clevertap) {
        console.warn(
          'CleverTap script was not loaded in the browser. Hence tracking page view failed'
        );
        return;
      }
      clevertap.event.push('pageview', { screenName, category });
    } catch (e) {
      console.error(
        'Error encountered while trying to send page view event to CleverTap',
        e
      );
    }
  }
};

track.identifyUserToAnalytics = identifyUserToAnalytics;

export { track, trackPageView };
